import { render, staticRenderFns } from "./go-index.vue?vue&type=template&id=0a23ce20&scoped=true"
import script from "./go-index.vue?vue&type=script&lang=js"
export * from "./go-index.vue?vue&type=script&lang=js"
import style0 from "./go-index.vue?vue&type=style&index=0&id=0a23ce20&prod&scoped=true&lang=css"
import style1 from "./go-index.vue?vue&type=style&index=1&id=0a23ce20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a23ce20",
  null
  
)

export default component.exports